import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "akademika/akamont/constants/Routes";
import {
  GetUserPartnerId,
  IsUserInternal,
  UserHasRoleOrHigher,
} from "../../services/AuthService";
import DependentBusinessUnitPartnerDataUtil from "../../utils/DependentBusinessUnitPartnerDataUtil";
import { BusinessUnitAndPartnerFilterData } from "akademika/akamont/models/BusinessUnitAndPartnerFilterData";
import { FilterController } from "../sharedControllers/FilterController";
import { Route$MatchedEvent } from "sap/ui/core/routing/Route";
import { BusinessUnitAndPartnerSelectData } from "../../models/ExceptionSelectData";
import CustomComboBox from "../../customControls/CustomComboBox";

/**
 * @namespace akademika.akamont.pages.priceListOverview
 */
export default class PriceListOverview extends FilterController {
  route = Routes.PRICE_LIST_OVERVIEW;
  parentRoute = Routes.DASHBOARD;

  emptyFilter: BusinessUnitAndPartnerFilterData = {
    businessUnitId: undefined,
    partnerId: undefined
  };

  public onInit() {
    super.onInit();

    this.initFilters(
      this.emptyFilter,
      "api/ServicePrice/GetServicePriceListOverview"
    );
  }

  public override async _onRouteMatched(oEvent: Route$MatchedEvent) {
    this.setUserRolesModel();
    await this.updateFilterOptions();

    if (GetUserPartnerId()) {
      const filtersModel = this.getModel("filters") as JSONModel;
      const filterOptions: BusinessUnitAndPartnerSelectData = this.getModelData("filterOptions");

      if (filterOptions.businessUnits.length === 1) {
        const businessUnitComboBox = this.byId("businessUnit") as CustomComboBox;
        businessUnitComboBox.setEditable(false);
      }

      filtersModel.setProperty("/businessUnitId", filterOptions.businessUnits[0].businessUnitId);
      filtersModel.setProperty("/partnerId", filterOptions.partners[0].partnerId);

      await this.applyFilters();
    } else {
      super._onRouteMatched(oEvent);
    }
  }

  private setUserRolesModel() {
    this.setModel(
      new JSONModel({
        isAdmin: UserHasRoleOrHigher("Admin"),
        isInternal: IsUserInternal(),
      }),
      "userRoles"
    );
  }

  public async updateFilterOptions() {
    const dependentBusinessUnitPartnerDataUtil =
      new DependentBusinessUnitPartnerDataUtil(this);

    const filters = this.getModelData<BusinessUnitAndPartnerFilterData>("filters");

    // remove old local storage filters data
    localStorage.removeItem(super.getFiltersStorageKey());

    await dependentBusinessUnitPartnerDataUtil.UpdateSelectData(
      filters.businessUnitId,
      filters.partnerId,
      "filterOptions"
    );
  }

  public async updateFilterOptionsAndApplyFilters() {
    await this.updateFilterOptions();
    await this.applyFilters();
  }

  public override async resetFilters() {
    await super.resetFilters();
    await this.updateFilterOptions();
  }

  public async openLegend() {
    await this.openDialog("Legend");
  }

  public closeLegend() {
    this.closeDialog();
  }

  public goToPriceDetailsOverview(servicePriceId: number) {
    this.navTo(Routes.PRICE_DETAILS_OVERVIEW, { servicePriceId });
  }
}
